export enum EDailyRewardType {
  coins = 'coins',
  empty = 'empty',
  achievement = 'achievement',
}

export enum EDailyRewardSlotStatus {
  opened = 'opened',
  available = 'available',
  locked = 'locked',
}
